import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
  Form,
  List,
  Card,
  Button,
  Radio,
  Checkbox,
  Spin,
  notification,
} from 'antd';
import _ from 'lodash';
import $ from 'jquery';
import qs from 'query-string';
import {
  SearchOutlined,
  CopyOutlined,
  FormOutlined,
  ShopOutlined,
} from '@ant-design/icons';
import './styles.module.scss';
import AppHelper from 'libs/AppHelper';
import { API_HOST } from '../../configs/env';
import whttp from '../../libs/whttp';
import { genFormItemAtrribute } from 'libs/FormHelper';
import { RadioControl, CheckboxControl } from '@wordpress/components';
import { withState } from '@wordpress/compose';
import bannerImage from 'assets/img/banner/banner-catalog.png';
import { store } from '../../reducers';
import { updateAuthInfo } from '../../reducers/auth';
import { __ } from '@wordpress/i18n';

const VC_CONFIG = _.get(window, 'VC_CONFIG', {});
const defaultListInfo = {
  current: 1, //目前頁數
  page_size: 10, //一頁幾筆
  total: 1, //以此query條件，總共幾筆資料
  rows: [],
};
// 前端頁面
export default class UserLogin extends Component {
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
    To: null,
    ContactData: {},
  };
  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\]]/g, '\\$&');

    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  componentDidMount() {
    var To = AppHelper.getLocalStorage('to-href');
    const ContactData = AppHelper.getLocalStorage('contact-data');

    if (this.getParameterByName('state') !== 'C4') {
      this.getCampaigns();
      return;
    }

    if (To) {
      this.setState({ To: To }, () => {
        AppHelper.removeLocalStorage('to-href');
      });
      if (ContactData)
        this.setState({ ContactData: ContactData }, () => {
          this.exchangeToken(
            this.getParameterByName('code'),
            this.getParameterByName('spcode')
          );
          AppHelper.removeLocalStorage('contact-data');
        });
      console.log('sso', To, ContactData);
    } else
      this.exchangeToken(
        this.getParameterByName('code'),
        this.getParameterByName('spcode')
      );

    // 登入換 tokne
    //http://cec.syscom.tw:8880/api/account/getAccessToken?code=4854c9565059992e98a33fbcde41597f
    // 電子發票列表
    // http://{{hostip}}//api/account/eInvoiceList
    // 點數紀錄 / 消費記錄
    // 密碼變更
    // 查詢編輯會員資料
    // 查詢好康卡會員資料
  }
  getCampaigns = () => {
    whttp.get(API_HOST + `/api/campaigns/config`, {}, (state, res) => {
      console.log(state, res);

      const {
        code = 100,
        reason = __('發生錯誤', 'cec-plugin-stores'),
        data = {},
      } = res;

      if (state === false) {
        return notification['error']({
          message: __('登入失敗，請稍候在試', 'cec-plugin-stores'),
          onClose: () => {
            //window.location.href = VC_CONFIG.INDEX_URL;
          },
        });
      }

      if (code !== 200) {
        notification['error']({
          message: __('登入失敗', 'cec-plugin-stores'),
          description: reason,
          onClose: () => {
            //window.location.href = VC_CONFIG.INDEX_URL;
          },
        });

        return;
      }
      const campaignCode = this.getParameterByName('state'); //

      if (_.has(res, `data.${campaignCode}`)) {
        const auth_url = _.get(res, `data.${campaignCode}.auth_url`);
        const targetUrl =
          auth_url +
          '?' +
          qs.stringify({
            code: this.getParameterByName('code'),
            spcode: this.getParameterByName('spcode'),
          });
        window.location.href = targetUrl;
      }
    });
  };
  exchangeToken = (code, spcode) => {
    this.props.cleanAuthInfo();

    if (code == null || spcode == null) {
      return notification['error']({
        message: __('登入失敗，請稍候在試', 'cec-plugin-stores'),
        onClose: () => {
          window.location.href = VC_CONFIG.INDEX_URL;
        },
      });
    }
    whttp.get(
      API_HOST + `/api/account/getAccessToken?code=${code}&spcode=${spcode}`,
      {},
      (state, res) => {
        console.log(state, res);
        this.setState({ isSubmitData: false });

        const {
          code = 100,
          reason = __('發生錯誤', 'cec-plugin-stores'),
          data = {},
        } = res;

        if (state === false) {
          return notification['error']({
            message: __('登入失敗，請稍候在試', 'cec-plugin-stores'),
            onClose: () => {
              //window.location.href = VC_CONFIG.INDEX_URL;
            },
          });
        }

        if (code !== 200) {
          notification['error']({
            message: __('登入失敗', 'cec-plugin-stores'),
            description: reason,
            onClose: () => {
              //window.location.href = VC_CONFIG.INDEX_URL;
            },
          });

          return;
        }
        console.log('store', updateAuthInfo);
        this.props.updateAuthInfo({ authorization: data.token });

        AppHelper.updateUserInfo(() => {
          var link = VC_CONFIG.INDEX_URL;
          notification['success']({
            message: __('登入成功', 'cec-plugin-stores'),
            duration: 1,
            onClose: () => {
              if (this.state.To) {
                link = link + this.state.To;
                if (this.state.ContactData) {
                  link =
                    link +
                    '?data=' +
                    encodeURIComponent(JSON.stringify(this.state.ContactData));
                }
              } else {
                link = VC_CONFIG.INDEX_URL + '/profile';
              }
              console.log('sso網頁轉至: ', link);
              window.location.href = link;
            },
          });
        });
      }
    );
  };
  render() {
    return (
      <div
        style={{ height: '350px' }}
        className='jumbotron d-flex align-items-center'
      >
        <div className='text-center'>
          <Spin
            className='mt-4'
            size='large'
            tip={__('登入中...', 'cec-plugin-stores')}
          />
        </div>
      </div>
    );
  }
}

// 編輯器
export class UserLoginEditor extends Component {
  formRef = React.createRef();
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  };
  componentDidMount() {
    AppHelper.updateConfig();
    console.log('kkk', this.props.attributes);

    this.formRef.current.setFieldsValue(this.props.attributes);
  }
  render() {
    const listInfo = this.state.listInfo;
    const options = _.get(this, 'props.app.options', {});
    console.log('editor', this.props);

    return (
      <div className='vu-blocks-editor'>
        <h2>OCA-會員 SSO 登入模組</h2>
        <Form ref={this.formRef} name='basic' className='basicForm' />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/users/user-sso-login.js